import MDBox from "components/MDBox";
import { useMyViewsQuery } from "graphql/types/graphql";
import { linearGradientStyle } from "utils/linearGradientsStyle";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import colors from "assets/theme-dark/base/colors";
import { scrollbar } from "utils/scrollBar";
import { useContext, useEffect } from "react";
import { context } from "utils/Provider";

interface Column {
  id: "id" | "name";
  label: string;
}

const columns: Column[] = [
  {
    id: "name",
    label: "Table Name",
  },
];

function Tables(): JSX.Element {
  const { setIsLoading, selectedCube } = useContext(context);

  // TODO ! implement pagination !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  const tables = useMyViewsQuery({
    variables: {
      cubeId: selectedCube.cubeId,
    },
  });
  const { data, loading, error } = tables;

  useEffect(() => {
    setIsLoading(loading);
  }, [loading, setIsLoading]);

  if (error) {
    <Typography>Error: {String(error)}</Typography>;
  }

  return (
    <MDBox
      sx={{
        borderRadius: "0",
        boxShadow: "none",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        padding: "1rem",
        ...linearGradientStyle,
      }}
    >
      <TableContainer
        sx={{
          color: colors.text.main,
          height: "100%",
          background: "transparent",
          borderRadius: "0px",
          maxHeight: "500px",
          ...scrollbar,
        }}
      >
        <Table sx={{ width: "100%" }} stickyHeader>
          <TableHead sx={{ width: "100%", backgroundColor: colors.background.default }}>
            {columns.map((column) => (
              <TableCell align="center" sx={{ color: colors.text.main }} key={column.id}>
                {column.label}
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {!loading &&
              data.myViews.edges.map((row, index) => {
                return (
                  <TableRow
                    sx={{
                      color: colors.text.main,

                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                    key={index}
                  >
                    <TableCell align="center" sx={{ color: colors.text.main }}>
                      <a href={`/tables/${row.name}`}>{row.name}</a>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </MDBox>
  );
}

export default Tables;
